import { render, staticRenderFns } from "./StudyCreate.vue?vue&type=template&id=760bba31"
import script from "./StudyCreate.vue?vue&type=script&lang=js"
export * from "./StudyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports